var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeManagementRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-62",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hourglass--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.73 407.87 297.04 290.15 233.35 407.87 360.73 407.87",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.73 208.72 297.04 326.43 233.35 208.72 360.73 208.72",
    style: {
      fill: "#5C8CB0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,278.22l-9.32,17.22a2.67,2.67,0,0,1-4.7,0l-9.32-17.22a10.21,10.21,0,0,1,9-15.06h5.39A10.21,10.21,0,0,1,308.71,278.22Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.05,378.15,327,390.05a2.67,2.67,0,0,1-1,5.13H268.13a2.67,2.67,0,0,1-1-5.13L296,378.15A2.65,2.65,0,0,1,298.05,378.15Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 351.8,
    r: 3.71,
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 313.05,
    r: 1.91,
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.04,
    cy: 331.52,
    r: 2.17,
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,402.06H233.67a5.82,5.82,0,0,0-5.8,5.81h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,402.06Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,202.92H233.67a5.82,5.82,0,0,0-5.8,5.8h0a5.82,5.82,0,0,0,5.8,5.8H360.41a5.82,5.82,0,0,0,5.8-5.8h0A5.82,5.82,0,0,0,360.41,202.92Z",
    style: {
      fill: "#5C8CB0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.63 405.68 187.58 403.39 191.96 386.76 199.01 389.05 194.63 405.68",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,402.45l7.92,2.57a.54.54,0,0,1,.37.65l-1.65,6.4a1.31,1.31,0,0,1-1.64.85c-2.74-.94-4-1.53-7.49-2.66-2.15-.7-9.21-2.52-12.17-3.48s-1.93-3.86-.59-3.72c6,.63,11.4.35,13.9-.57A2.09,2.09,0,0,1,187.47,402.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.01 389.06 191.96 386.76 189.7 395.34 196.76 397.63 199.01 389.06",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.28,220.72s-12.65,58.55-15.62,79.6c-3.25,23.05-15.46,92.27-15.46,92.27l13.09,3.62s18.14-67.13,23.44-89.54c5.75-24.33,21-86,21-86Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,239.92c-5,11.34-7.47,36-5.53,47.35,3.54-14.55,7.8-31.85,11.09-45.16C238.37,238.25,236.53,234,233.92,239.92Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.62 396.47 186.6 392.61 186.88 386.9 202.66 392.35 200.62 396.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,402.87a9.63,9.63,0,0,0,2,.36.18.18,0,0,0,.16-.28c-.18-.23-1.73-2.24-2.7-2.18a.65.65,0,0,0-.54.34,1,1,0,0,0-.08,1A2,2,0,0,0,184.57,402.87Zm1.59,0c-1.34-.16-2.26-.5-2.48-.93a.62.62,0,0,1,.07-.63.32.32,0,0,1,.26-.17C184.53,401.08,185.51,402.06,186.16,402.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,403.22h.08a.18.18,0,0,0,.13-.11c0-.08.85-2.06.36-3a.85.85,0,0,0-.62-.45.66.66,0,0,0-.76.3c-.41.72.16,2.53.73,3.18Zm0-3.17a.5.5,0,0,1,.31.26,3.85,3.85,0,0,1-.27,2.39,3.52,3.52,0,0,1-.51-2.53c0-.09.14-.19.39-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,165.13c-.38.9-.7,1.58-1.05,2.34s-.73,1.46-1.1,2.18c-.74,1.45-1.52,2.86-2.33,4.27a82.48,82.48,0,0,1-5.4,8.18,62,62,0,0,1-6.65,7.59,38.5,38.5,0,0,1-8.68,6.42l-.25.13a5.17,5.17,0,0,1-1.28.46,14.21,14.21,0,0,1-6.87-.27,20,20,0,0,1-5.24-2.44,34,34,0,0,1-7.24-6.56,60.17,60.17,0,0,1-5.27-7.31,65.7,65.7,0,0,1-4.13-7.85,3.24,3.24,0,0,1,5.47-3.35l.1.12c1.65,2,3.44,4.13,5.24,6.07a68.41,68.41,0,0,0,5.58,5.48,27.46,27.46,0,0,0,5.74,4,8.46,8.46,0,0,0,2.47.82,2.74,2.74,0,0,0,1.44-.12l-1.53.59a29.94,29.94,0,0,0,5.61-4.9,61.91,61.91,0,0,0,5-6.42c1.58-2.3,3.08-4.71,4.49-7.19.72-1.23,1.41-2.48,2.06-3.75l1-1.89c.31-.61.65-1.31.89-1.8l.06-.14a6.5,6.5,0,0,1,11.85,5.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.39,178.71c3.14-8.34,9.81-8.48,12.7-6.27-.21.39-.43.78-.65,1.17a84.91,84.91,0,0,1-5.15,7.91A65.35,65.35,0,0,1,216,188.9c-.72.71-1.46,1.41-2.23,2.09A32,32,0,0,1,215.39,178.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,172.79l-6.5.24,1.62-6.95a33.54,33.54,0,0,1,6.63,1,2.63,2.63,0,0,1,1.41,4h0A3.91,3.91,0,0,1,176,172.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.64,166.92a6.28,6.28,0,0,0-2.15-1.11c-.54,2.84-4,7.63-4,7.63h2.71a2.38,2.38,0,0,0,1.83-.85l1.9-2.28A2.37,2.37,0,0,0,179.64,166.92Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.52 169.83 166.34 164.93 171.1 166.09 169.48 173.03 164.52 169.83",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.25 408.92 238.84 408.92 238.58 391.75 245.99 391.75 246.25 408.92",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.45,408.06h8.33a.53.53,0,0,1,.55.51l.4,6.59a1.32,1.32,0,0,1-1.3,1.32c-2.9-.05-4.28-.22-8-.22-2.25,0-9.78.23-12.89.23s-3-3.08-1.71-3.36c5.92-1.24,11.2-3,13.29-4.61A2.07,2.07,0,0,1,238.45,408.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246 391.76 238.58 391.76 238.72 400.61 246.13 400.61 246 391.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74,220.72s-2.83,64.41-1.63,85.64c1.32,23.24,4.08,92.11,4.08,92.11h13.58s3.42-67,4.24-90c.89-25,4.92-87.75,4.92-87.75Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.32 398.47 234.65 398.47 233.53 393.01 249.72 393.82 249.32 398.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.82,409.35a9.69,9.69,0,0,0,2-.26.2.2,0,0,0,.13-.14.19.19,0,0,0-.07-.17c-.24-.17-2.34-1.6-3.25-1.24a.66.66,0,0,0-.4.48,1,1,0,0,0,.22.94A2,2,0,0,0,235.82,409.35Zm1.5-.51c-1.33.26-2.3.22-2.65-.12a.64.64,0,0,1-.12-.62.3.3,0,0,1,.19-.24C235.23,407.67,236.46,408.29,237.32,408.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.76,409.09a.13.13,0,0,0,.08,0,.18.18,0,0,0,.09-.14c0-.09.17-2.22-.58-2.94a.87.87,0,0,0-.73-.24.66.66,0,0,0-.62.52c-.18.81.93,2.36,1.67,2.8A.15.15,0,0,0,237.76,409.09Zm-1-3a.5.5,0,0,1,.37.15,3.83,3.83,0,0,1,.49,2.36c-.64-.55-1.38-1.73-1.27-2.26,0-.1.08-.22.33-.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64,160.94a4.72,4.72,0,0,0-4-5.5h-.08c-2.39-.35-5.39-.71-8.33-.85a147.89,147.89,0,0,0-16.85,0c-2.59.24-5.12.67-7.14,1.06l-.08,0a7.08,7.08,0,0,0-5.39,4.94c-2.42,8.15-5.31,24.79-1.53,60.12h39.65c.28-3.54-.51-15.06.07-29.73A234.86,234.86,0,0,1,261.64,160.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,163.12c-.82,4.74-1.83,11.19-2.53,18,0,0-3.62-7.1-4.28-13.17S259,161.42,261.26,163.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.67,164.06a.38.38,0,0,1-.17-.71l12.36-6.41a.38.38,0,0,1,.5.16.38.38,0,0,1-.16.51L234.84,164A.47.47,0,0,1,234.67,164.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.33,164.64a.33.33,0,0,1-.26-.11l-6.78-6.73a.39.39,0,0,1,0-.53.38.38,0,0,1,.53,0l6.77,6.74a.38.38,0,0,1,0,.53A.36.36,0,0,1,240.33,164.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,154.58a147.71,147.71,0,0,0-16.84,0l-.28,0a4,4,0,0,0,.43,3.07c.94,1.5,2.91,2.34,5.87,2.5l1.11,0c8,0,11.09-4.86,11.22-5.07l.28-.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,154.52c4.9-1.16,5.76-4.19,5.43-7.52a19.92,19.92,0,0,0-.39-2.48l6.14-5.1,4.51-3.74c-1.25,5.43-2.66,15.32,1,18.94,0,0-3,5-11.43,4.56C231.41,158.79,233.22,154.52,233.22,154.52Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.26,144.52a19.92,19.92,0,0,1,.39,2.48c2.29-.46,5.35-2.9,5.67-5.24a10.66,10.66,0,0,0,.08-2.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,118.5c-3.33,2-2.8,7-3.7,10.58,2.12.21,5.46-3.56,5.46-3.56l2-5.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,128.56c-2.13,7.06-3,11.29-7.52,14.24a9.59,9.59,0,0,1-14.92-8.11c0-6.73,3.46-17.15,11.18-18.59A9.7,9.7,0,0,1,252.71,128.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.06,134.55c5-5.8-1.25-8.66,3.86-12.69-5.75.27-15.22-.14-16.91-4.08s3.51-9.28,7.84-9.78c5-.58,3.92,5.61,3.92,5.61s19.13-1.19,13.06,7c4.6-.28,3.33,7.16-4.67,13.44C251.15,134.72,246.06,134.55,246.06,134.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.68,120.71s3.94-1.17,3.81-4.29C261.91,117.4,262.06,120.38,256.68,120.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.88,135.93a7.91,7.91,0,0,1-4.55,2.77c-2.27.41-2.8-1.69-1.67-3.74,1-1.84,3.43-4.27,5.47-3.76S255.33,134.14,253.88,135.93Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.32,128.38c-.14.58-.56,1-.95.91s-.58-.61-.44-1.19.56-1,.94-.92S241.46,127.79,241.32,128.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.69,127.05c-.14.58-.56,1-.94.92s-.59-.61-.45-1.19.56-1,.94-.92S234.83,126.47,234.69,127.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.73,127.76a22.22,22.22,0,0,1-4,4.42,3.42,3.42,0,0,0,2.68,1.09Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.45,135.31a5.13,5.13,0,0,0,3.85-1.24.16.16,0,0,0,0-.24.18.18,0,0,0-.25,0,4.89,4.89,0,0,1-4.22,1.05.17.17,0,0,0-.2.14.18.18,0,0,0,.14.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.88,126.76a.27.27,0,0,0,.17,0,.34.34,0,0,0,.17-.46,3.36,3.36,0,0,0-2.47-2,.36.36,0,0,0-.4.3.35.35,0,0,0,.31.39,2.69,2.69,0,0,1,1.92,1.58A.36.36,0,0,0,243.88,126.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.05,123.07a.32.32,0,0,0,.32-.06,2.89,2.89,0,0,1,2.52-.59.35.35,0,1,0,.22-.67h0a3.64,3.64,0,0,0-3.17.71.35.35,0,0,0-.06.49A.3.3,0,0,0,233.05,123.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,158.09l.83,1.13.75,1.06c.5.71.95,1.42,1.42,2.13.91,1.43,1.77,2.88,2.6,4.34a95.76,95.76,0,0,1,4.52,9c.7,1.52,1.3,3.1,1.94,4.65s1.18,3.16,1.67,4.78a88.81,88.81,0,0,1,2.6,9.83l.08.38a5.22,5.22,0,0,1-.71,3.94,28.6,28.6,0,0,1-4.55,5.39,23.54,23.54,0,0,1-6,4,21.55,21.55,0,0,1-6.86,1.9,20.48,20.48,0,0,1-3.5.06c-.58,0-1.16-.11-1.74-.2l-.88-.17-1-.25a.46.46,0,0,1-.34-.55l1.38-5.8c0-.05.26-.06.42-.1l.55-.11c.38-.08.75-.17,1.13-.27a15.91,15.91,0,0,0,2.17-.76,15.5,15.5,0,0,0,3.79-2.23,19.16,19.16,0,0,0,5.26-6.85l-.63,4.32c-.86-2.83-1.77-5.63-2.87-8.4s-2.3-5.49-3.61-8.17-2.71-5.33-4.22-7.91c-.74-1.29-1.52-2.56-2.3-3.82l-1.19-1.86-.59-.9-.55-.8-.2-.3A6.49,6.49,0,0,1,262,158.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.78,209.48,246.63,213l9.33-.37s2.45-6.28-.89-7.27l-1.3.35A8.56,8.56,0,0,0,248.78,209.48Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,204.55a6.26,6.26,0,0,0-1.7,1.71c2.54,1.38,6.08,6.08,6.08,6.08l.82-2.58a2.38,2.38,0,0,0-.27-2L256,205.26A2.38,2.38,0,0,0,252.62,204.55Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.45 218.42 255.14 217.74 255.96 212.63 246.63 213 247.45 218.42",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.06,96.34l-.51-.86a35.39,35.39,0,0,1,4.57-2.28l.38.93A33.38,33.38,0,0,0,153.06,96.34Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,114l-1-.34A34.81,34.81,0,0,1,149.77,97.3l.59.81A33.7,33.7,0,0,0,138.46,114Z",
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.2,
    cy: 125.39,
    r: 30.78,
    style: {
      fill: "#5C8CB0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,125.39a25.71,25.71,0,1,1-6.72-17.34.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,125.39a25.71,25.71,0,0,1-43.15,18.89,25.71,25.71,0,0,1,36.43-36.23.06.06,0,0,1,.05,0A25.66,25.66,0,0,1,195.91,125.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,126.89a1.49,1.49,0,0,1-1.06-.44L156.6,113.91a1.5,1.5,0,1,1,2.12-2.12l11.48,11.48,6.63-6.63a1.5,1.5,0,0,1,2.12,2.12l-7.69,7.69A1.51,1.51,0,0,1,170.2,126.89Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeManagementRafiki);
export default __webpack_public_path__ + "static/media/Time_management-rafiki.fcba0e16570d087b197326c6a847bf32.svg";
export { ForwardRef as ReactComponent };